module.exports = __webpack_public_path__ + "static/headers_freezed-478208e1fcfdda44562bd405d5eed80f.jpg";